import React, { useCallback } from 'react';
import Button from '@stone/ui/button/Button';
import classNames from 'classnames';
const BagInfoBox = (props) => {
    const renderHeading = useCallback(() => {
        const classname = 'font__title';
        if (props.heading)
            return React.createElement(props.heading, { className: classname }, React.createElement(React.Fragment, null, props.title));
        return React.createElement("p", { className: classname }, props.title);
    }, [props.heading]);
    return (React.createElement("div", { className: classNames('bag-info-box', props.className) },
        props.title && renderHeading(),
        props.text && React.createElement("p", null, props.text),
        props.children,
        props.buttonAction && (React.createElement(Button, { type: "button", cls: props.buttonCls || ['button--tertiary'], onClick: props.buttonAction, ariaHaspopup: "dialog" }, props.buttonText))));
};
BagInfoBox.defaultProps = { heading: 'p' };
export default BagInfoBox;
